import React, { useEffect, useState } from "react";
import firebase from "../../services/FirebaseService";
import { Link, Redirect  } from "react-router-dom";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../../context/FirebaseAuthContext";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import "../../assets/style/admin/live-chats.css";
import UserService from "../../services/UserService";
import SupportService from "../../services/SupportService";

const Chats = () => {

	const supportService = new SupportService();
	
	const [ chats, setChats ] = useState([]);
	const [ pending, setPending ] = useState(true);

	useEffect(() => {

		(async () => {
			if(pending) {
				try {
					const chatsList = await supportService.getAllChats();
	
					setChats(chatsList);
					setPending(false);
				}
				catch(error) {
					console.error(error);
				}
			}
		})();
			
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	if(pending) {
		return <></>;
	}

	return (
		<section id="chats-list">
			<h1>Active Chats</h1>
			{ chats.length === 0 && <p>No Chats yet</p> }
			{ chats.length > 0 && chats.map(chat => (
				<Link to={`/admin/chats/${chat.id}`} key={chat.id}>
					<div className="chat-card">
						<h2>{chat.name}</h2>
					</div>
				</Link>
			))}
			
		</section>
	);
}


const LiveChatsPage = () => {

	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	firebase.auth().onAuthStateChanged(async user => {
		
		if(user) {
			const isAdmin = await userService.isUserAdmin(user.uid);

			isAdmin ? setPriviledged(1) : setPriviledged(2);
		}
		else {
			setPriviledged(2);
		}

	});

	return (
		<>
			<AuthProvider>
				<IfFirebaseAuthed>
					<Navbar />
					<Chats privileged={privileged} />
					<Footer />
				</IfFirebaseAuthed>
				<IfFirebaseUnAuthed>
					<Redirect to="/auth/login" />
				</IfFirebaseUnAuthed>
			</AuthProvider>
		</>
	)
};

export default LiveChatsPage;